<template lang="pug">
	.user-panel
		template(v-if="$auth.authenticated()")
			.user-info
				.image-container
					.user-image(v-if="$userInfo.user && $userInfo.user.HasPhoto", :style="{ background: `url(${$userInfo.photo})` }")
					.user-image(v-else, :style="{ background: `url(${require('../assets/default-user-image.png')})` }")
				.flex-col.user-name.align-start
					.text-overflow {{userName}}
					.text-overflow.font-small.grey(v-if="$userInfo.user") {{$auth.company().Name}}
			dx-context-menu(
				v-if="menuMode === 'context'"
				target=".user-button"
				:items="displayMenuItems"
				:width="170"
				show-event="dxclick"
				css-class="user-menu"
			)
				dx-position(my="top center" at="bottom center")
			dx-list(
				v-if="menuMode === 'list'"
				class="dx-toolbar-menu-action"
				:items="menuItems"
			)
</template>

<script>
	import DxContextMenu, { DxPosition } from 'devextreme-vue/context-menu';
	import DxList from 'devextreme-vue/list';
	import auth from '../auth';
	import _ from 'lodash';

	export default {
		name: 'user-panel',
		props: {
			menuMode: String,
			menuItems: Array
		},
		components: {
			DxContextMenu,
			DxPosition,
			DxList
		},
		data() {
			return {
				selectedLanguage: null,
				isChanging: false,
			}
		},
		computed: {
			userName() {
				return auth && auth.displayUserName();
			},
			userPhoto() {
				return auth.userPhoto();
			},
			languageItems() {
				return this.$locale?.state?.availableLocales?.map(f => ({
					text: f.label,
					onClick: () => this.selectLanguage(f),
					icon: f.code === (this.$locale?.state?.currentLocale?.code || 'en-EN') ? 'check' : ''
				}))
			},
			displayMenuItems() {
				return _.orderBy([
					...this.menuItems, 
					...(this.languageItems?.length ? [{ text: this.$tCaption('Language'), icon: 'fas fa-language', items: this.languageItems }] : []),
					...(this.$auth.isWorkingOnBehalfOfCompany() || this.$userInfo.availableCompanies?.length > 1 ? [{
						text: this.$tCaption('Switch to'),
						icon: 'fas fa-arrow-right',
						items: this.$userInfo.availableCompanies.map(f => ({
							text: f.Name,
							onClick: () => this.switchToCompany(f),
							disabled: () => f.Oid === this.$auth.companyId(),
							icon: f.Oid === this.$auth.companyId() ? 'far fa-square-check' : 'fas fa-arrow-right-to-bracket'
						}))
					}] : [])
				], f => f.index || 0);
			}
		},
		watch: {
			'$auth.userPhoto'() {
				if (__DEBUG__)
					console.debug('Photo loaded/changed');
				this.$forceUpdate();
			},
			'$locale.state.currentLocale.code'(v) {
				this.isChanging = true;
				this.selectedLanguage = v;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.isChanging = false;
				})
			},
			selectedLanguage(curr, prev) {
				if (this.isChanging) return;
				localStorage.setItem('locale', curr)
				this.$locale.actions.refreshI18n(true);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.userPanel = this;
		},
		methods: {
			selectLanguage(lang) {
				if (__DEBUG__)
					console.debug('On language select', { lang });
				this.selectedLanguage = lang.code;
			},
			switchToCompany(company) {
				this.$confirm(void 0, this.$tCaption('Do you want to login as "<COMPANY>"?').replace(/<COMPANY>/g, company.Name)).then(() => {
					this.$auth.switchToCompany(company.Oid);
				});
			}
		}
	};
</script>

<style lang="scss">
	@import "../themes/generated/variables.base.scss";

	.user-info {
		display: flex;
		align-items: center;

		.dx-toolbar-menu-section & {
			padding: 10px 6px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		}

		.image-container {
			overflow: hidden;
			border-radius: 50%;
			height: 30px;
			width: 30px;
			min-height: 30px;
			min-width: 30px;
			margin: 0 4px;
			border: 1px solid rgba(0, 0, 0, 0.1);
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

			.user-image {
				width: 100%;
				height: 100%;
				background-size: 120% !important;
				background-position: center !important;
			}
		}

		.user-name {
			font-size: 14px;
			color: $base-text-color;
			margin: 0 9px;
			line-height: 14px;
			white-space: nowrap;
			max-width: 280px;
			overflow: hidden;
			> * {
				text-overflow: ellipsis;
			}
		}
	}

	.user-panel {
		.dx-list-item .dx-icon {
			vertical-align: middle;
			color: $base-text-color;
			margin-right: 16px;
		}
		.dx-rtl .dx-list-item .dx-icon {
			margin-right: 0;
			margin-left: 16px;
		}
	}

	.dx-context-menu.user-menu.dx-menu-base {
		&.dx-rtl {
			.dx-submenu .dx-menu-items-container .dx-icon {
				margin-left: 16px;
			}
		}
		.dx-submenu .dx-menu-items-container .dx-icon {
			margin-right: 16px;
		}
		.dx-menu-item .dx-menu-item-content {
			padding: 3px 15px 4px;
		}
	}

	.dx-theme-generic .user-menu .dx-menu-item-content .dx-menu-item-text {
		padding-left: 4px;
		padding-right: 4px;
	}
</style>
